import { useEffect, useState } from 'react'
import type { ReactNode} from 'react';

import testHandle from '../../utils/testHandle'
import Icon from '../Icon/Icon'
import { IconTypes } from '../Icon/Icon.helpers'
import { AlertButton, CloseButton } from './Alert.styles'

export type AlertProps = {
  id: string
  label: string | ReactNode
  onClick?: () => void
  isSuccess?: boolean
  variant?: 'default' | 'outlined'
}

const Alert = ({ label, onClick, id, isSuccess, variant = 'default' }: AlertProps) => {
  const [isVisible, setIsVisible] = useState(true)

  // Needed so that we can re-use the same alert component
  // at least until we feature out the alert 'queue' solution
  useEffect(() => {
    if (!isVisible) setIsVisible(true)
  }, [isVisible])

  const handleClick = () => {
    setIsVisible(false)
    onClick && onClick()
  }

  return isVisible ? (
    <AlertButton role="alert" data-testid={testHandle(id)} isSuccess={!!isSuccess} variant={variant}>
      <span>{label}</span>
      <CloseButton
        type="button"
        className="closeButton"
        isSuccess={!!isSuccess}
        onClick={handleClick}
        variant={variant}
      >
        <Icon name={IconTypes.Close} />
      </CloseButton>
    </AlertButton>
  ) : null
}

export default Alert
